import type { OrderType } from '@/models';

export const orderTypes: OrderType[] = [
  {
    symbol: 'Ri',
    label: 'Remake (with invoice)',
    default: false,
  },
  {
    symbol: 'Si',
    label: 'Sample (with invoice)',
    default: false,
  },
  {
    symbol: 'Oi',
    label: 'Order (with invoice)',
    default: true,
  },
  //   {
  //     symbol: 'Vi',
  //     label: 'Vanx (with invoice)',
  //     default: false,
  //   },
  {
    symbol: 'R',
    label: 'Remake (no invoice)',
    default: false,
  },
  {
    symbol: 'Si',
    label: 'Sample (no invoice)',
    default: false,
  },
  {
    symbol: 'Ci',
    label: 'Compensation (no invoice)',
    default: false,
  },
  {
    symbol: 'Coi',
    label: 'Commission offset (no invoice)',
    default: false,
  },
  //   {
  //     symbol: 'V',
  //     label: 'Vanx (no invoice)',
  //     default: false,
  //   },
];
